export { default } from './MultipleWinnersCarousel';
export * from './MultipleWinnersCarousel';
